import { palette } from "@/theme/constants";
export const styles = (isDarkTheme?: true) => ({
  input: {
    '& input:-webkit-autofill': {
      WebkitTextFillColor: palette.background, 
    },

    '& .MuiFormHelperText-root.Mui-error': {
      marginBottom: 0,
    },

    '& .MuiOutlinedInput-root': {
      backgroundColor: palette.white,
      height: '100%',
      transition: "border-color 0.3s ease-in-out",
    },

    '& .MuiOutlinedInput-input': {
      color: palette.background,
      backgroundColor: palette.white,
      height: '50px', 
      marginLeft: '18px',

      '::placeholder': {
        color: '#00000040',
        opacity: 1,
      },
    },

    '& .MuiOutlinedInput-notchedOutline': {
      borderWidth: "1px",
      borderColor: palette.gray,  // Default border color is gray
      transition: "border-color 0.3s ease-in-out",
    },

    // Change border color when input is focused
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: "rgba(119, 188, 229, 1) !important", 
      borderWidth: "1px !important",
    },

    // Change border color when input has a value (even after losing focus)
    '& .MuiOutlinedInput-root.MuiInputBase-formControl:not(.Mui-focused) .MuiOutlinedInput-notchedOutline': {
      borderColor: palette?.gray, // Keep border dark blue if the input has a value
    },

    '& .MuiInputLabel-root.Mui-focused': {
      color: "rgba(119, 188, 229, 1)", 
    },

    '& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline': {
      borderColor: palette?.gray,
    },

    '& .MuiInputLabel-root': {
      fontSize: '1.2rem',
      color: palette.background, 
      transition: "color 0.3s ease-in-out",

      '&.Mui-error': {
        color: '#fff !important',
      },

      '&.Mui-focused': {
        color: "#77BCE5",
      },

      '&.Mui-error.Mui-focused': {
        color: palette.error,
      },

      '&.MuiInputLabel-shrink': {
        top: '0px',
      },
    },
  },
});


